( function($) {
  "use strict";
  var body = $('body');
  var viewportWidth = $(window).width();
  var viewportHeight = $(window).height();
  /*
  These functions make sure WordPress
  and Foundation play nice together.
  */

  $(document).ready(function() {

    // Remove empty P tags created by WP inside of Accordion and Orbit
    $('.accordion p:empty, .orbit p:empty').remove();

    // Adds Flex Video to YouTube and Vimeo Embeds
    $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
      if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
        $(this).wrap("<div class='widescreen responsive-embed'/>");
      } else {
        $(this).wrap("<div class='responsive-embed'/>");
      }
    });

    var form = body.find('.form-container'),
        wpMenu = body.find('.wp-menu');

    // NEWS SMOOTH SCROLL
    $('#NewsTrigger').on('click', function(e){

      var target = $(this.hash);

      $('html, body').animate({
        scrollTop: target.offset().top
      }, 1000);


      var mainMenu = $('.wp-menu').find('.menu-container');
      var menuleft = $('.sidebar-menu');
      
      $('.hamburger-icon').removeClass('active');
      $('html').toggleClass('no-scroll');
      body.toggleClass('cbp-spmenu-push-toright');
      menuleft.toggleClass('cbp-spmenu-open');
      body.find('.logo').toggleClass('hide');
      mainMenu.toggleClass('hide');
      body.find('.form-container').toggleClass('hide');
      body.toggleClass('noScroll');
    });

    body.find('.form-close-btn').on('click', function(){
      wpMenu.slideDown('200');
      form.slideUp('200');
    });

  }); // End of Document Ready

    body.find('.hero-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 300,
      dots: false,
      infinite: false,
      adaptiveHeight: true,
      arrows: false
    });

    body.find('.image-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      dots: false,
      infinite: false,
      arrows: true,
      prevArrow: '<button class="slick-prev"><img src="/content/themes/DailyPress/assets/images/arrow-left.svg" alt="arrow-left"/></button>',
      nextArrow: '<button class="slick-next"><img src="/content/themes/DailyPress/assets/images/arrow-right.svg" alt="arrow-right"/></button>',
      fade: true,
      cssEase: 'linear'
    });


    body.find('.news-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      prevArrow: '<button class="slick-prev"><img src="/content/themes/DailyPress/assets/images/arrow-left.svg" alt="arrow-left"/></button>',
      nextArrow: '<button class="slick-next"><img src="/content/themes/DailyPress/assets/images/arrow-right.svg" alt="arrow-right"/></button>',
      speed: 300,
      dots: false,
      infinite: false,
      adaptiveHeight: true,
      arrows: true,
      responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          infinite: false,
          centerMode: false
        }
      }
    ]
    });

  /********
   * Debounce function
   *
   * Returns a function, that, as long as it continues to be invoked, will not be triggered.
   * The function will be called after it stops being called for N milliseconds.
   * If `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
   *
   * Reference: https://davidwalsh.name/javascript-debounce-function
   ********/
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  /******
   * Mobile and Desktop  Menu Switch
   *
   * Desktop Menu: Second level menu dropdown
   * Mobile Menu: Second level menu slide to open
   ******/
  var menuState = "";
  var mobileDesktopMenuSwitch = debounce(function() {
    menuState = "mobile";
    var mainMenu = $('.wp-menu').find('.menu-container');
    var menuleft = $('.sidebar-menu');
    $('.hamburger-icon').on('click', function(e){
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).parents('.mobile-menu').toggleClass('first-level-open');
      body.find('.mobile-menu').removeClass('second-level-open');
      body.find('.menu-item-has-children').removeClass('open');
      $('html').toggleClass('no-scroll');
      body.toggleClass('cbp-spmenu-push-toright');
      menuleft.toggleClass('cbp-spmenu-open');
      body.find('.logo').toggleClass('hide');
      mainMenu.toggleClass('hide');
      body.find('.form-container').toggleClass('hide');
      body.toggleClass('noScroll');
    });

    $('.menu-item-has-children > a').click(function(e){
      e.preventDefault();
      $(this).parents('.mobile-menu').toggleClass('second-level-open');
      $(this).parent().toggleClass('open');
    });

    $('.menu-item-has-children > a').one('click', function(e){
      //This code onle need to run once
      $(this).siblings('.second-level-menu').find('.second-level-parent').append($(this).clone());
    });

    $('.mobile-menu .back-to-main').click(function(e) {
      $('.mobile-menu').removeClass('second-level-open');
      $('.menu-item-has-children').removeClass('open');
    });
  }, 250);

  mobileDesktopMenuSwitch(); //run one on load



  /******
   * Responsive Tab
   *
   * Desktop: Sidebar Tab
   * Mobile: Accordion
   ******/
  tabControl();

  var resizeTimer;
  $(window).on('resize', debounce(function(e) {
      tabControl();
  }, 250));

  function tabControl() {
    var tabs = $('.tabbed-content').find('.tabs');
    if(tabs.is(':visible')) {
      tabs.find('a').on('click', function(event) {
        event.preventDefault();
        var target = $(this).attr('href'),
            tabs = $(this).parents('.tabs'),
            buttons = tabs.find('a'),
            item = tabs.parents('.tabbed-content').find('.item');
        buttons.removeClass('active');
        item.removeClass('active');
        $(this).addClass('active');
        $(target).addClass('active');
      });
    } else {
      $('.item').on('click', function() {
        var container = $(this).parents('.tabbed-content'),
            currId = $(this).attr('id'),
            items = container.find('.item');
        container.find('.tabs a').removeClass('active');
        items.removeClass('active');
        $(this).addClass('active');
        container.find('.tabs a[href$="#'+ currId +'"]').addClass('active');
      });
    }
  }

})(jQuery);


